class AddonElement {
  constructor(addonEl){
    this._cacheElements(addonEl)
    this._init()
  }

  _init() {
    
    this.elements.toggle.addEventListener("click", () => this._onToggleClick())
    this.elements.options.forEach(el => {
      el.addEventListener("click", (e) => this._onOptionSelect(e))
    })
  }

  _cacheElements(addonEl) {
    this.elements = {
      container: addonEl,
      toggle: addonEl.querySelector(".addons__toggle"),
      optionsContainer: addonEl.querySelector(".addons__options"),
      options: addonEl.querySelectorAll(".addons__option"),
    }
  }

  _onToggleClick() {
    if (this.elements.toggle.ariaExpanded === "false") {
      this._openDropdown()
    } else {
      this._closeDropdown()
    }
  }

  _onOptionSelect(e) {
    const optionEl = e.currentTarget

    if (optionEl.classList.contains("selected")) {
      this._closeDropdown()
      return
    }

    this.elements.options.forEach(el => {
      el.classList.remove("selected")
    })
    optionEl.classList.add("selected")

    this._closeDropdown()
  }

  _openDropdown() {
    let height = 0 
    this.elements.options.forEach(el => {
      height += el.getBoundingClientRect().height
    })

    const toggleText = this.elements.toggle.querySelector("span")
    const defaultText = this.elements.toggle.getAttribute("data-default")
    if (toggleText.innerText !== defaultText) {
      this._updateToggleText(defaultText)
    }
    
    this.elements.toggle.setAttribute("aria-expanded", true)
    this.elements.optionsContainer.style.height = height + 'px'
  }

  _closeDropdown() {
    const selectedOptionEl = this.elements.optionsContainer.querySelector(".selected")
    const text = selectedOptionEl.hasAttribute("default-option") ? 
      this.elements.toggle.getAttribute("data-default") :
      selectedOptionEl.innerText
    this._updateToggleText(text)
    
    this.elements.toggle.setAttribute("aria-expanded", false)
    this.elements.optionsContainer.style.height = '0px'
  }

  _updateToggleText(text) {
    const toggleText = this.elements.toggle.querySelector("span")
    if (text === toggleText.innerText) {
      return
    }
    
    toggleText.style.opacity = 0
    setTimeout(() => {
      toggleText.innerText = text
      toggleText.style.opacity = 1
    }, 600)

    const defaultText = this.elements.toggle.getAttribute("data-default")
    this.elements.toggle.classList.toggle("selected", defaultText !== text)
  }
}

document.addEventListener('page:loaded', function() {
  document.querySelectorAll(".product__addons .addons").forEach(el => {
    new AddonElement(el)
  })
});